import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';

export default class ScrollNav extends PureComponent {
  render() {
    const {
      active,
      data,
      gotoItem,
      style,
      inverse,
    } = this.props;

    return (
      <nav style={{ ...style, overflow: 'auto' }}>
        <ol className={classnames('nav__list', inverse && 'scroll-nav--inverse')}>
          {data && !!data.length && data.map(item => (
            <MenuItem
              key={item.id}
              active={item.id === active}
              data={item}
              onClick={() => gotoItem(item)}
              inverse={inverse}
            />
          ))}
        </ol>
      </nav>
    );
  }
}

ScrollNav.displayName = 'ScrollNav';

ScrollNav.propTypes = {
  active: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({
    // In the Exchange menu, 'Sell my things' is null, and the jump button is a string
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
  })).isRequired,
  gotoItem: PropTypes.func.isRequired,
  inverse: PropTypes.bool,
  style: PropTypes.shape({}),
};

ScrollNav.defaultProps = {
  active: undefined,
  inverse: false,
  style: {},
};